// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wkcD","textarea":"styles_textarea__9xQ48"};